<template>
  <div>
    <b-card title="ویرایش کارت و سلفی">
      <div class="row">
        <div class="col-md-6" v-for="x in confs" v-bind:key="x.id">
          <h4 class="pt-5" v-if="x.mdid6_type == 1505">تصویر سلفی</h4>
          <h4 class="pt-5" v-if="x.mdid6_type == 1506">تصویر کارت ملی</h4>
          <h4 class="pt-5" v-if="x.mdid6_type == 1736">تصویر جواز کسب</h4>
          <br />
          <b-card :img-src="x.fileUrl">
            <h4>{{ x.user.fa_name }} {{ x.user.fa_family }}</h4>

            <div class="">
              <label>کد ملی: {{ x.user.national_card_number }}</label>
            </div>
            <div class="">
              <label>نام پدر: {{ x.user.fa_father }}</label>
            </div>
            <div class="">
              <label v-if="x.user.birth_date">تاریخ تولد: {{ getBDate(x.user.birth_date) }}</label>
            </div>
            <div class="">
              <label>وضعیت: {{ x.status.title }}</label>
            </div>
            <div class="" v-if="x.user_approver">
              <label>تایید کننده: {{ x.user_approver.name }}</label>
            </div>
            <div class="" v-if="x.user_approver">
              <label>تاریخ تایید: {{ getBDate(x.updated_at) }}</label>
            </div>
            <div>
              <b-button :disabled="x.mdid7_status == 1520 || x.mdid7_status == 1522" variant="success"
                @click="confirm(x)">تایید</b-button>
              <b-button :disabled="x.mdid7_status == 1520 || x.mdid7_status == 1522" class="ml-3" variant="danger"
                @click="
                  confItem = x;
                $bvModal.show('adddesc-modal');
                ">عدم تایید</b-button>
              <b-button target="_blank" :href="'#/viewclientdetails/' + x.user.id" class="ml-3"
                variant="warning">اطلاعات مشتری</b-button>
            </div>
            <div class="desc-note">
              <br />
              <b-card v-for="description in x.description" v-bind:key="description.id">{{ description.description
              }}</b-card>
            </div>
          </b-card>
        </div>
      </div>
      <v-snackbar v-model="snackbar"> عملیات با موفقیت انجام شد </v-snackbar>
    </b-card>
    <b-modal id="adddesc-modal" style="justify-content: space-around" hide-footer title="تگ جدید">
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form>
        <div>
          <b-row>
            <b-col>
              <b-form-group id="input-group-5" label="توضیحات: " label-for="input-5">
                <b-form-textarea required id="input-5" v-model="Input.description" placeholder="توضیحات"
                  rows="8"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <b-row class="mt-3">
          <b-col>
            <b-button style="width: 100%" variant="danger" @click="$bvModal.hide('adddesc-modal')">بازگشت</b-button>
          </b-col>
          <b-col>
            <b-button style="width: 100%" variant="primary" @click="unConfirm()">ذخیره</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<style>
.desc-note .card {
  margin-bottom: 10px;
}
</style>
<script>
import Axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import routesMap from "@/helpers/routesMap";
import persianDate from "../../helpers/persianDate";
import * as moment from "jalali-moment";
export default {
  name: "ConfirmNationalCode",
  data() {
    return {
      fileUrl: '',
      confs: [],
      errors: [],
      snackbar: false,
      Input: {
        description: "",
      },
      confItem: {},
      routesMap,
    };
  },
  components: {
    moment,
  },
  mounted() {
    this.getdata();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست کارت های ملی و سلفی ها",
        route: "/nationalcard",
      },
      {
        title: "ویرایش کارت و سلفی",
      },
    ]);
  },
  methods: {
    getdata() {
      httpHelper
        .getData("getalluserconf?id=" + this.$route.params.id)
        .then((res) => {
          this.confs = res.result.filter(o =>
            [1505, 1506, 1736].includes(o.mdid6_type)
          );
          // برای هر آیتم لینک فایل بگیر
          this.confs.forEach(conf => {
            if (conf?.value) {
              httpHelper.getImage(conf.value).then((imageUrl) => {
                this.$set(conf, 'fileUrl', imageUrl.result.url || '');
              })
            }
          });
        });
    },
    getBDate(date) {
      //return moment(date, 'YYYY-M-D HH:mm:ss').format('jYYYY/jM/jD')
      return persianDate.getDateByFormat(date);
    },
    unConfirm() {
      var conf = {
        id: this.confItem.id,
        mdid7_status: 1520,
        description: this.Input.description,
      };
      httpHelper.postData("userconf", conf).then((res) => {
        this.errors = [];
        if (res.success) {
          this.snackbar = true;
          this.getdata();
        } else {
          for (var key in res.error) {
            res.error[key].forEach((element) => {
              this.errors.push(element);
            });
          }
        }
      });
      this.$bvModal.hide("adddesc-modal");
      this.Input.description = "";
    },
    confirm(uc) {
      var conf = {
        id: uc.id,
        mdid7_status: 1522,
      };
      httpHelper.postData("userconf", conf).then((res) => {
        this.snackbar = true;
        this.getdata();
      });
    },
  },
};
</script>
